export default __webpack_public_path__ + "static/media/ID_SCHOOL_ASTA.398b4a22.jpg";